import axios from "../../../util/axios";

export default {
    /** 查询列表 */
    queryList: (data) => axios.get({url: "/basedata/system/log/queryList", data}),
    /** 查询详情 */
    findById: (id) => axios.get({url: "/basedata/system/log/findById?id=" + id}),

}